import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiRoutesService } from './api-routes.service';

/**
 * Sessions simultanées exploitant (CDC §2).
 *
 * Enregistre la session du token courant après un login/switch réussi. Si la
 * limite d'appareils est atteinte, le back répond 409 (corps
 * {@link SessionConflict}) : l'appelant affiche alors la modale Continuer/
 * Annuler, « Continuer » rappelant register(true) pour déconnecter l'autre
 * appareil. La déconnexion effective de l'autre appareil est portée par le
 * filtre serveur à sa prochaine requête (401 → logout via l'intercepteur).
 */
@Injectable({
  providedIn: 'root'
})
export class SessionService {

  readonly #httpClient = inject(HttpClient);
  readonly #routes = inject(ApiRoutesService);

  register(force = false): Observable<void> {
    return this.#httpClient.post<void>(this.#routes.registerSession(), { force });
  }

  /**
   * Libère la session du token donné (déconnexion volontaire). Le jeton est posé
   * explicitement : l'appelant vide le stockage juste après, l'intercepteur ne
   * le retrouverait plus.
   */
  release(accessToken: string): Observable<void> {
    return this.#httpClient.post<void>(this.#routes.logoutSession(), null, {
      headers: new HttpHeaders({ Authorization: 'Bearer ' + accessToken }),
    });
  }
}
